import React, { useContext } from 'react'
import styled from '@emotion/styled'

import { EmailCaptureForm } from '../EmailCaptureForm'
import { SiteConfigContext } from '../SiteConfigProvider'
import { BNDLogo } from '../svgs/BNDLogo'
import { BDCLogo } from '../svgs/BDCLogo'
import { descriptionText, EmailSignUpContainer, FormContainer, headerText } from './'

const ContextContainer = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	${({ theme }) => theme.MQ.XL} {
		flex-direction: row;
	}
`
const ContextHeader = styled.div`
	${({ theme }) => theme.fonts.primarySemiBold};
	color: ${({ theme }) => theme.colors.tertiary};
	font-size: 28px;

	${({ theme }) => theme.MQ.M} {
		font-size: 32px;
	}
`
const DetailText = styled.div`
	${({ theme }) => theme.fonts.header};
	color: ${({ theme }) => theme.colors.primary};
	margin: 1rem 0;
`
const LogosContainer = styled.div`
	align-content: flex-start;
	align-items: center;
	display: flex;
	flex-direction: row;
	flex-flow: row wrap;
	justify-content: normal;
	margin-bottom: 1rem;
	width: 100%;

	${({ theme }) => theme.MQ.XL} {
		flex-direction: row;
		flex-flow: row wrap;
		width: 50%;
	}
`
const Ampersand = styled.div`
	${({ theme }) => theme.fonts.header};
	color: ${({ theme }) => theme.colors.primary};
	font-size: 50px;
	margin: 0;

	${({ theme }) => theme.MQ.M} {
		margin: 1rem;
	}

	${({ theme }) => theme.MQ.XL} {
		font-size: 75px;
		padding-left: 0.5rem;
		margin: 0;
		font-weight: 600px;
	}
`

export function EmailSignUpMessagingBoxBnd() {
	const {
		siteConstants: {
			EMAIL_CAPTURE_SOURCES: { article },
		},
	} = useContext(SiteConfigContext)

	return (
		<EmailSignUpContainer>
			<ContextHeader>{headerText}</ContextHeader>
			<DetailText>{descriptionText}</DetailText>
			<ContextContainer>
				<LogosContainer>
					<BNDLogo height="60" width="200" />
					<Ampersand>&amp;</Ampersand>
					<BDCLogo color="black" circleFillColor="black" height="35" width="275" />
				</LogosContainer>
				<FormContainer>
					<EmailCaptureForm source={article} />
				</FormContainer>
			</ContextContainer>
		</EmailSignUpContainer>
	)
}
